import { ListItem, ListProps, Text, UnorderedList } from "@chakra-ui/react"

type DepositCarouselModalInfoPointsProps = ListProps & {
  infoPoints: string[]
}

export default function DepositCarouselModalInfoPoints({
  infoPoints,
  ...props
}: DepositCarouselModalInfoPointsProps) {
  return (
    <UnorderedList px="12px" {...props}>
      {infoPoints.map((infoPoint, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <ListItem key={`info-point-${index}`}>
          <Text
            variant="label"
            fontWeight={500}
            lineHeight={1.4}
            letterSpacing="0.12px"
            color="#1D1D1D"
            fontFamily="riforma.medium"
          >
            {infoPoint}
          </Text>
        </ListItem>
      ))}
    </UnorderedList>
  )
}
